var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _g2, _g3, _g4, _rect2, _rect3, _path23, _path24, _path25, _g5, _g6, _g7, _rect4, _path26, _path27, _path28, _path29, _path30, _path31, _rect5, _path32, _path33, _rect6, _rect7, _path34, _rect8, _rect9, _circle, _path35, _path36, _path37, _path38, _path39, _rect10, _rect11, _rect12, _path40, _rect13, _path41, _path42, _path43, _rect14, _path44, _rect15, _path45, _path46, _path47, _path48, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path49, _path50, _g8, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path88, _path89, _g9, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g10, _ellipse, _path98, _g11, _path99, _path100, _path101, _path102, _path103;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 740.433,
    height: 645.772,
    viewBox: "0 0 740.433 645.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.747,
    y1: -0.203,
    x2: 0.253,
    y2: 1.203,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7d6ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "website",
    transform: "translate(6013 -1688)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(0.19 -0.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M2952.139,1552.3c0,173.758-41.754,286.338-280.792,315.268-88.688,10.734-101.18-138.827-199.228-137.347-143.812,2.17-166.161-100.895-157.415-141.036,27.717-127.223,235.469-438.064,358.558-346.078C2914.243,1423.2,2952.139,1378.547,2952.139,1552.3Z",
    transform: "translate(-8282.227 461.76)",
    fill: "#0095ff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M3008.85,1563.513c0,173.758-210.86,233.25-443.067,302.973-142.488,42.784-317.775-152.174-295.427-300.8,28.567-189.978,217.979-381.651,341.068-289.665C2852.406,1456.109,3008.85,1389.756,3008.85,1563.513Z",
    transform: "translate(-8281.607 461.4)",
    fill: "#0095ff",
    opacity: 0.09
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(-6812 401.447)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M1292.08,1534.16c0,2.072-.056,4.143-.138,6.187a148.366,148.366,0,0,1-16.212,61.921,149.844,149.844,0,1,1-260.888-146.96,147.714,147.714,0,0,1,18.7-24.25,149.824,149.824,0,0,1,258.541,103.1Z",
    transform: "translate(23.288 1.226)",
    fill: "#fad2f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M1079.321,1514.989c-6.342,12.658-10.025,9.9-9.334,5.753,1.251-7.505-6.675,3.682-11.047,3.913-4.973.262,5.293-11.047-1.382-15.522-4.908-3.29-15.522,3.425-16.239,18.615-.664,15.19,11.406,28.668,3.12,39.716s-11.406-5.855-14.167-8.976,0,11.047-4.475,8.285-13.119-16.212-13.119-46.262,5.883-41.083,4.834-47.988c-.69-4.53-1.547-13.022-4.5-20.507a147.714,147.714,0,0,1,18.7-24.25c1.822,3.646,3.977,6.96,8.23,7.458,8.645,1.049,41.787-19.334,44.908-13.451,3.094,5.883-7.622,17.262-15.549,23.476s-8.645,20.714-4.144,23.835c4.5,3.092,14.5-21.073,25.216-12.1,10.69,8.977-8.644,20.383-9.334,31.072S1085.846,1501.965,1079.321,1514.989Z",
    transform: "translate(25.121 4.516)",
    fill: "#eba9d7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M1276.981,1531.314c0,2.072-.056,4.143-.138,6.187-5.053,7.871-14.2,11.628-15.41,7.981-1.713-5.192-4.807-5.523-10.689-.359s-9.308,3.453-9.667-10.026c-.359-13.451-8.977-1.712-8.977,8.645s9.336,17.592-.69,33.142-19.333,16.572-28.641,39.357c-9.335,22.786-17.952,21.4-24.526,13.119s4.475-14.168,2.431-24.857c-2.1-10.689,20.356-12.429,17.235-25.547-3.094-13.119-10.33,4.833-23.118,2.071s-12.787-24.167-2.4-35.546c10.331-11.406,24.857-3.121,36.569-9,11.765-5.854-1.38-19.333,9.334-26.237s1.382-16.572-5.192-7.236c-6.546,9.335-8.617,5.524-17.593,2.762s-8.644,6.573-23.835,20.024-18.974-15.882,3.811-27.26c22.786-11.406,23.477-20.383,19.665-29.718-3.784-9.307-20,13.147-24.857.719-4.807-12.429-1.022-23.477,12.1-19s12.429,1.382,12.429-19.333c0-16.738,15.107-17.7,30.713-12.9A149.462,149.462,0,0,1,1276.981,1531.314Z",
    transform: "translate(38.388 4.071)",
    fill: "#eba9d7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M1259.133,1586.081a150.387,150.387,0,0,1-83.244,73.108c6.932-7.651,8.893-16.323,17.759-21.432,11.406-6.546,21.432-6.546,28.337-25.52,6.9-19,16.213-14.527,22.759-29.36C1250.958,1568.875,1263.331,1545.261,1259.133,1586.081Z",
    transform: "translate(39.886 17.412)",
    fill: "#001d8d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M1100.822,1411.223c-16.413,8.206,9.667,8.285,11.738,19.333s-16.571,37.976-2.416,44.191c0,0,12.083,5.179,21.75-10.7s14.5-4.833,20.714-14.5,2.417-9.666,2.417-22.095-5.524-14.846-11.393-13.81-8.631-2.762-15.536-5.179S1104.964,1409.151,1100.822,1411.223Z",
    transform: "translate(32.607 3.329)",
    fill: "#eba9d7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M1083.906,1522.681c-16.893,1.126-10.357,13.119-17.952,28.655s-13.119,17.952-3.8,28.654,21.4-11.047,26.239,15.19,3.452,23.131,11.392,35.214,21.75,19.678,21.75,8.631-6.214-11.047,6.215-27.273,12.774-17.952,6.559-20.714-4.143-4.143-1.726-11.047,1.036-11.047-6.214-15.19-14.5-1.726-17.607-14.155,1.036-16.916-6.215-19.333S1089.084,1522.336,1083.906,1522.681Z",
    transform: "translate(29.154 13.74)",
    fill: "#001d8d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M1155.613,1533.584c-11.1,3.026-4.143,9.9-7.365,13.118s-7.825,7.135-5.063,14.961,12.2,6.674,12.888.69-.23-25.547,5.064-28.309,4.373-8.056,0-5.064S1158.145,1532.892,1155.613,1533.584Z",
    transform: "translate(36.851 14.231)",
    fill: "#001d8d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M1130.62,1481.544s-5.116,3.714-7.8,3.193a3.682,3.682,0,0,1-.733-.22c-2.064-.882-2.541-3.378-2.2-1.694a7.1,7.1,0,0,0,1.853,3.309,31.547,31.547,0,0,1-7-2.806,5.85,5.85,0,0,1-.882-.679s1.094-15.032,4.225-13.453c1.986,1.005,3.388,3.732,4.605,6.139a20.582,20.582,0,0,0,1.967,3.45,1.274,1.274,0,0,0,.151.158C1126.624,1480.979,1130.62,1481.544,1130.62,1481.544Z",
    transform: "translate(34.274 8.892)",
    fill: "#440c01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M1120.9,1488.82c.168.556-7.773.882-7.773.556a27.336,27.336,0,0,0-.581-3.855,6.588,6.588,0,0,0-.679-1.941c-.83-1.208.052-3.414.82-3.361a9.326,9.326,0,0,1,2.2.714c.256.4.574.837.927,1.305C1117.766,1484.868,1120.765,1488.353,1120.9,1488.82Z",
    transform: "translate(34.064 9.9)",
    fill: "#f4b595"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M1115.817,1482.239c-.617.062-1.333-.088-1.385.2a9.339,9.339,0,0,1-1.888,3.08,6.588,6.588,0,0,0-.679-1.941c-.83-1.208.052-3.414.82-3.361a9.326,9.326,0,0,1,2.2.714C1115.146,1481.33,1115.463,1481.771,1115.817,1482.239Z",
    transform: "translate(34.064 9.9)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M1106.515,1472.754c-2.279,2.794-2.72,12.2-1.4,13.38s7.94-1.177,8.675-1.912,2.573-6.4,2.5-7.057S1106.515,1472.754,1106.515,1472.754Z",
    transform: "translate(33.417 9.225)",
    fill: "#f4b595"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M1114.749,1478.407c1.507-.551,2.647-.367,2.831.882.177,1.2-1.324,2.463-2.316,2.611a2.477,2.477,0,0,1-1.948-1.4A12.019,12.019,0,0,1,1114.749,1478.407Z",
    transform: "translate(34.225 9.71)",
    fill: "#f4b595"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M1111.014,1495.845c-1.764,3.583-5.073,10.365-4.741,11.689s1.047,6.837,2.977,5.845,6.285-4.577,5.459-8.437A42.9,42.9,0,0,0,1111.014,1495.845Z",
    transform: "translate(33.586 11.314)",
    fill: "#e0a689"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M1109.506,1514.688c.828-5.183-.827-28.4-2.647-29.388s-3.639.937-6.781,1.433-5.017-.385-5.183,0,2.591,2.758,4.191,2.978,5.679-2.536,5.955-1.82.22,6.671-.552,11.468-2.812,13.068-.33,15.218S1109.506,1514.688,1109.506,1514.688Z",
    transform: "translate(32.558 10.334)",
    fill: "#ebae8f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M1116.794,1478.289s-.073,1.177-2.793,1.029-4.632-.037-5.845-1.912a2.639,2.639,0,0,1,.33-3.344s-2.94,3.344-3.822,1.36,2.521-5.619,7.02-6.543c5.551-1.14,7.242.368,7.242.368Z",
    transform: "translate(33.43 8.836)",
    fill: "#440c01"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M1181.1,1496.722s-5.319-8.049-6.661-12.284-3.736.667-3.708,1.991,6.3,26.189,12.793,27.374S1181.1,1496.722,1181.1,1496.722Z",
    transform: "translate(39.419 10.129)",
    fill: "#369106"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M1143.371,1505.719c5.22-3.529,11.587-.839,16.1,1.764,2.518,1.451,5.44.368,15.806,2.572s11.175,3.381,11.248,3.088-2.139-2.947-1.764-13.012c.44-11.836,1.177-20.952,1.911-21.394s3.454-2.132,3.676-1.1.368,12.571,1.764,21.981,3.087,12.792-.147,18.158c-2.969,4.927-35.582,8.675-54.035,2.206S1143.371,1505.719,1143.371,1505.719Z",
    transform: "translate(35.819 9.637)",
    fill: "#42ab09"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M1182.107,1475.826s-.239.785-.61,1.72a9.017,9.017,0,0,1-1.394,2.567c-.08.088-.177.213-.282.345-1.226,1.632-3.732,6.219-3.926,6.581-.212.4-1.517-1.288-3.158-.538s-2.029,2.964-2.594,2.425-1.817-5.09-1.676-6.245c.123-1.033,6.326-4.632,11.671-6.326.291-.08.574-.168.847-.248C1181.366,1476,1181.745,1475.9,1182.107,1475.826Z",
    transform: "translate(39.213 9.503)",
    fill: "#246306"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M1180.568,1477.522a9.017,9.017,0,0,1-1.394,2.567c-.08.088-.177.213-.282.345a6.985,6.985,0,0,1,.317-4.1c.291-.08.574-.168.847-.248C1180.2,1476.464,1180.382,1476.985,1180.568,1477.522Z",
    transform: "translate(40.143 9.526)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M1198.058,1472.68c-3.657-1.523-16.487.442-17.92,3.309s.386,6.561.661,6.4,2.15-2.059,3.088-2.223,2.2,1.176,2.7,1.341c.7.232,1.653-2.591,3.915-4.135S1199.381,1473.232,1198.058,1472.68Z",
    transform: "translate(40.221 9.17)",
    fill: "#2a7306"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M1143.008,1509.8c-2.426,3.529-1.693,9.262-1.844,9.853s-13.3-3.969-18-6.034a40.358,40.358,0,0,1-12.943-9.7c-3.238-3.67.609-9.148,2.646-16.611.221-.812,6.688-.882,8.231-.151a22.441,22.441,0,0,1,3.273,3.468c4.279,5.063,11.222,13.973,12.607,15.209,1.605,1.42,7.507-1.333,9.713-2.126a2.093,2.093,0,0,1,.8-.185C1148.081,1503.73,1145.434,1506.27,1143.008,1509.8Z",
    transform: "translate(33.832 10.481)",
    fill: "#ffc70f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M1121.03,1491.4c-4.518.723-9.594,21.062-9.924,21.172s-15.715-1.213-18.471-1.323-11.909,5.4-13.233,5.789.882,2.536,6.617.276,5.679-3.86,5.679-3.86a52.425,52.425,0,0,0,12.019,4.577c5.679,1.158,7.555,2.812,8.822,1.984s8.271-8.38,10.532-16.375S1125.165,1490.738,1121.03,1491.4Z",
    transform: "translate(31.124 10.906)",
    fill: "#f4b595"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M1096.886,1518.2h-25.309a.431.431,0,0,1-.432-.432h0a.431.431,0,0,1,.432-.432h25.309a.432.432,0,0,1,.432.432h0A.432.432,0,0,1,1096.886,1518.2Z",
    transform: "translate(30.41 13.258)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 24.675,
    height: 0.864,
    rx: 0.385,
    transform: "translate(1089.855 1509.988) rotate(58.991)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M1129.938,1481.025s-5.116,3.714-7.8,3.193a3.683,3.683,0,0,1-.733-.22,3.057,3.057,0,0,0,2.241-3.017c-.141-1.271-1.659-4.208-1.641-6.167a20.579,20.579,0,0,0,1.967,3.45,1.265,1.265,0,0,0,.151.158C1125.941,1480.46,1129.938,1481.025,1129.938,1481.025Z",
    transform: "translate(34.957 9.411)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M1145.41,1503.373c-.282.362-.662.742-.908,1.076-.6.83-6.226,3.061-9.481,2.346-3.052-.679-6.963-7.321-11.93-16.5,4.279,5.063,11.222,13.973,12.607,15.209C1137.3,1506.92,1143.2,1504.167,1145.41,1503.373Z",
    transform: "translate(35.109 10.811)",
    fill: "#e69600"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(1407.195 1553.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M1383.875,1603.315a32.443,32.443,0,1,1,32.445-32.442A32.48,32.48,0,0,1,1383.875,1603.315Zm0-63.543a31.1,31.1,0,1,0,31.1,31.1A31.136,31.136,0,0,0,1383.875,1539.771Z",
    transform: "translate(-1351.43 -1538.429)",
    fill: "#eba2b7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(1426.713 1554.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M1382.284,1603.4c-7.264,0-12.955-14.133-12.955-32.176s5.691-32.176,12.955-32.176,12.955,14.133,12.955,32.176S1389.548,1603.4,1382.284,1603.4Zm0-63c-6.289,0-11.6,14.115-11.6,30.822s5.313,30.822,11.6,30.822,11.6-14.115,11.6-30.822S1388.572,1540.405,1382.284,1540.405Z",
    transform: "translate(-1369.329 -1539.051)",
    fill: "#eba2b7"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(1408.819 1575.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 61.082,
    height: 1.355,
    fill: "#eba2b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(0 18.962)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 61.082,
    height: 1.355,
    fill: "#eba2b7"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 79.429,
    height: 53.922,
    rx: 4.206,
    transform: "translate(1357.973 1586.038)",
    fill: "#db819b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 70.988,
    height: 46.819,
    transform: "translate(1362.529 1590.289)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M1393.793,1620.439H1300.38a6.041,6.041,0,0,1-6.041-6.041h105.5A6.041,6.041,0,0,1,1393.793,1620.439Z",
    transform: "translate(50.601 22.038)",
    fill: "#eba2b7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M1341.511,1583.491l27.073-4.67a.522.522,0,0,1,.579.692l-8.412,23.053a.522.522,0,0,1-.856.193l-18.662-18.383A.522.522,0,0,1,1341.511,1583.491Z",
    transform: "translate(54.829 18.819)",
    fill: "#e089a2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M1336.973,1609.613l-20.43-3.837a.509.509,0,0,1-.148-.948l37.1-20.115a.51.51,0,0,1,.682.189l5.583,9.469a.509.509,0,0,1-.16.685l-22.258,14.483A.511.511,0,0,1,1336.973,1609.613Z",
    transform: "translate(52.572 19.347)",
    fill: "#e089a2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(907.362 1513.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M900.624,1530.482a1.4,1.4,0,0,1-.9-.324,18.39,18.39,0,0,1-.183-28.181,1.41,1.41,0,0,1,1.825,2.148,15.57,15.57,0,0,0,.157,23.86,1.41,1.41,0,0,1-.9,2.5Z",
    transform: "translate(-893.061 -1501.64)",
    fill: "#eba2b7"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(895.572 1507.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M890.78,1537.094a1.409,1.409,0,0,1-1.069-.489,30.845,30.845,0,0,1-.141-40.067,1.41,1.41,0,0,1,2.148,1.826,28.025,28.025,0,0,0,.128,36.4,1.41,1.41,0,0,1-1.066,2.331Z",
    transform: "translate(-882.249 -1496.04)",
    fill: "#eba2b7"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(883.623 1501.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M881.105,1543.614a1.411,1.411,0,0,1-1.128-.562,43.509,43.509,0,0,1-5.138-43.291,43.357,43.357,0,0,1,5-8.672,1.41,1.41,0,0,1,2.26,1.685,40.71,40.71,0,0,0-4.673,40.31,39.94,39.94,0,0,0,4.8,8.271,1.411,1.411,0,0,1-1.125,2.26Z",
    transform: "translate(-871.292 -1490.52)",
    fill: "#eba2b7"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 18.622,
    height: 23.506,
    rx: 2.333,
    transform: "translate(976.334 1539.679) rotate(180)",
    fill: "#eba2b7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M913.009,1557.06l30.954-27.119v-23.506L913.02,1478.96a2.136,2.136,0,0,0-3.554,1.6v74.9A2.136,2.136,0,0,0,913.009,1557.06Z",
    transform: "translate(15.785 9.737)",
    fill: "#eba2b7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M1425.869,1674.458h-56.925l1.12-1.042a2.006,2.006,0,0,1,.734-.142h53.257a1.682,1.682,0,0,1,.682.129Z",
    transform: "translate(57.35 27.364)",
    fill: "#05005c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M1426.159,1675.273v34.273a2.066,2.066,0,0,1-1.171,1.866,1.956,1.956,0,0,1-.914.219h-53.257a1.964,1.964,0,0,1-.94-.231,2.076,2.076,0,0,1-1.145-1.854v-34.273a1.927,1.927,0,0,1,.155-.785.25.25,0,0,1,.063-.116h56.99a.254.254,0,0,1,.064.116A1.927,1.927,0,0,1,1426.159,1675.273Z",
    transform: "translate(57.33 27.463)",
    fill: "#db819b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M1425.869,1676.493h-56.925l1.12-1.042,25.74-24.029a2.334,2.334,0,0,1,3.2,0l25.727,24.016Z",
    transform: "translate(57.35 25.329)",
    fill: "#eb94ac"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M1424.893,1710.4a1.954,1.954,0,0,1-.914.219h-53.257a1.964,1.964,0,0,1-.94-.231l.206-.194,25.74-24.028a2.334,2.334,0,0,1,3.2,0l25.727,24.016Z",
    transform: "translate(57.425 28.473)",
    fill: "#eb94ac"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M1425.952,1674.372l-.116.116-26.794,24.955a2.371,2.371,0,0,1-3.214,0l-26.807-24.955-.115-.116Z",
    transform: "translate(57.346 27.463)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 8.828,
    height: 48.204,
    transform: "translate(865.417 1640.485) rotate(-49.781)",
    fill: "#e089a2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M889.447,1648.21l7.749,6.553a.577.577,0,0,1-.144.972,11.555,11.555,0,1,1,6.778-8.016.577.577,0,0,1-.935.3l-7.749-6.553a.576.576,0,0,0-.811.069l-4.956,5.86A.576.576,0,0,0,889.447,1648.21Z",
    transform: "translate(13.218 23.773)",
    fill: "#e089a2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M865.353,1622.057a11.5,11.5,0,0,1-20-10.041.577.577,0,0,1,.935-.3l8.733,7.385a.576.576,0,0,0,.811-.068l4.956-5.861a.577.577,0,0,0-.068-.811l-8.733-7.386a.577.577,0,0,1,.144-.972,11.507,11.507,0,0,1,13.222,18.057Z",
    transform: "translate(9.957 21.015)",
    fill: "#e089a2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 435.811,
    height: 272.289,
    rx: 17.642,
    transform: "translate(945.589 1531.372)",
    fill: "#804d9e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 393.177,
    height: 230.854,
    transform: "translate(966.905 1552.09)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    d: "M5.979,0H600.012a5.979,5.979,0,0,1,5.979,5.979V8.745A20.112,20.112,0,0,1,585.88,28.857H20.112A20.112,20.112,0,0,1,0,8.745V5.979A5.979,5.979,0,0,1,5.979,0Z",
    transform: "translate(861.608 1794.597)",
    fill: "#9d5fc2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 393.821,
    height: 230.798,
    transform: "translate(966.539 1551.816)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 393.867,
    height: 24.361,
    transform: "translate(966.539 1551.816)",
    fill: "#b6a4eb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 4.439,
    cy: 4.439,
    r: 4.439,
    transform: "translate(977.268 1559.557)",
    fill: "#ebefff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M1082.315,1543.872h-46.423a4.466,4.466,0,0,0-4.465,4.467h0a4.466,4.466,0,0,0,4.465,4.467h46.423a4.467,4.467,0,0,0,4.466-4.467h0A4.467,4.467,0,0,0,1082.315,1543.872Z",
    transform: "translate(26.817 15.658)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M1153.222,1543.872H1106.8a4.466,4.466,0,0,0-4.465,4.467h0a4.466,4.466,0,0,0,4.465,4.467h46.423a4.466,4.466,0,0,0,4.465-4.467h0A4.466,4.466,0,0,0,1153.222,1543.872Z",
    transform: "translate(33.232 15.658)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M1224.129,1543.872h-46.423a4.467,4.467,0,0,0-4.466,4.467h0a4.467,4.467,0,0,0,4.466,4.467h46.423a4.466,4.466,0,0,0,4.465-4.467h0A4.466,4.466,0,0,0,1224.129,1543.872Z",
    transform: "translate(39.646 15.658)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M1295.036,1543.872h-46.423a4.467,4.467,0,0,0-4.466,4.467h0a4.467,4.467,0,0,0,4.466,4.467h46.423a4.466,4.466,0,0,0,4.465-4.467h0A4.466,4.466,0,0,0,1295.036,1543.872Z",
    transform: "translate(46.06 15.658)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M1176.512,1587.94h-90.27a5.919,5.919,0,0,1-5.919-5.919h0a5.92,5.92,0,0,1,5.919-5.92h90.27a5.92,5.92,0,0,1,5.919,5.92h0A5.919,5.919,0,0,1,1176.512,1587.94Z",
    transform: "translate(31.24 18.574)",
    fill: "#a992eb"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 102.108,
    height: 62.153,
    rx: 4.919,
    transform: "translate(1111.563 1674.586)",
    fill: "url(#linear-gradient)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 102.108,
    height: 62.153,
    rx: 4.919,
    transform: "translate(991.697 1674.586)",
    fill: "url(#linear-gradient)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 102.108,
    height: 62.153,
    rx: 4.919,
    transform: "translate(1230.69 1674.586)",
    fill: "url(#linear-gradient)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M1146.463,1632.045h-34.776a5.92,5.92,0,0,1-5.919-5.92h0a5.919,5.919,0,0,1,5.919-5.919h34.776a5.919,5.919,0,0,1,5.919,5.919h0A5.92,5.92,0,0,1,1146.463,1632.045Z",
    transform: "translate(33.542 22.564)",
    fill: "#9377e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 83.611,
    height: 5.919,
    rx: 2.714,
    transform: "translate(1120.812 1745.618)",
    fill: "#c7d6ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M1169.795,1731.129H1092.1a2.959,2.959,0,0,1-2.96-2.959h0a2.96,2.96,0,0,1,2.96-2.961h77.691a2.96,2.96,0,0,1,2.959,2.961h0A2.959,2.959,0,0,1,1169.795,1731.129Z",
    transform: "translate(32.039 32.062)",
    fill: "#e6eeff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M1146.117,1741.816H1092.1a2.959,2.959,0,0,1-2.96-2.959h0a2.96,2.96,0,0,1,2.96-2.961h54.014a2.96,2.96,0,0,1,2.96,2.961h0A2.959,2.959,0,0,1,1146.117,1741.816Z",
    transform: "translate(32.039 33.029)",
    fill: "#ebf1ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M1035.94,1741.816H981.926a2.959,2.959,0,0,1-2.959-2.959h0a2.96,2.96,0,0,1,2.959-2.961h54.015a2.96,2.96,0,0,1,2.959,2.961h0A2.959,2.959,0,0,1,1035.94,1741.816Z",
    transform: "translate(22.072 33.029)",
    fill: "#ebf1ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 83.611,
    height: 5.919,
    rx: 2.714,
    transform: "translate(1000.945 1745.618)",
    fill: "#c7d6ff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M1059.49,1731.129H981.8a2.959,2.959,0,0,1-2.959-2.959h0a2.96,2.96,0,0,1,2.959-2.961h77.691a2.961,2.961,0,0,1,2.961,2.961h0A2.96,2.96,0,0,1,1059.49,1731.129Z",
    transform: "translate(22.06 32.062)",
    fill: "#e6eeff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 83.611,
    height: 5.919,
    rx: 2.714,
    transform: "translate(1240.309 1745.618)",
    fill: "#c7d6ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M1279.378,1731.044h-77.691a2.959,2.959,0,0,1-2.959-2.959h0a2.959,2.959,0,0,1,2.959-2.959h77.691a2.959,2.959,0,0,1,2.96,2.959h0A2.959,2.959,0,0,1,1279.378,1731.044Z",
    transform: "translate(41.951 32.055)",
    fill: "#e6eeff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M1276.278,1741.646h-40.325a2.959,2.959,0,0,1-2.959-2.959h0a2.959,2.959,0,0,1,2.959-2.959h40.325a2.959,2.959,0,0,1,2.96,2.959h0A2.959,2.959,0,0,1,1276.278,1741.646Z",
    transform: "translate(45.051 33.014)",
    fill: "#ebf1ff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M1225.607,1600.238H1044.328a3.7,3.7,0,0,1-3.7-3.7h0a3.7,3.7,0,0,1,3.7-3.7h181.279a3.7,3.7,0,0,1,3.7,3.7h0A3.7,3.7,0,0,1,1225.607,1600.238Z",
    transform: "translate(27.65 20.088)",
    fill: "#bfaeeb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M1179.733,1614.939h-135.4a3.7,3.7,0,0,1-3.7-3.7h0a3.7,3.7,0,0,1,3.7-3.7h135.4a3.7,3.7,0,0,1,3.7,3.7h0A3.7,3.7,0,0,1,1179.733,1614.939Z",
    transform: "translate(27.65 21.418)",
    fill: "#d7cef0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "matrix(0.88, -0.475, 0.475, 0.88, 1190.091, 1615.905)",
    fill: "#642f8a"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "translate(1248.558 1597.9) rotate(17.895)",
    fill: "#642f8a"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "translate(1208.413 1722.915) rotate(17.895)",
    fill: "#642f8a"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "matrix(0.88, -0.475, 0.475, 0.88, 1250.589, 1732.309)",
    fill: "#642f8a"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "translate(1301.364 1625.694) rotate(62.201)",
    fill: "#642f8a"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "translate(1184.461 1685.557) rotate(62.201)",
    fill: "#642f8a"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 33.66,
    height: 23.214,
    rx: 3.096,
    transform: "translate(1194.082 1643.802) rotate(107.112)",
    fill: "#642f8a"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M1272.664,1660.942l-6.405,20.83-1.511,4.872a3.351,3.351,0,0,1-3.612,2.351,2.058,2.058,0,0,1-.61-.1l-8.419-2.6-7.308-2.246a3.37,3.37,0,0,1-2.225-4.221l2.246-7.307,1.68-5.417,3.99-13a3.369,3.369,0,0,1,4.22-2.226l7.454,2.289,8.273,2.562A3.354,3.354,0,0,1,1272.664,1660.942Z",
    transform: "translate(45.904 25.414)",
    fill: "#642f8a"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M1271.472,1650.284a67.287,67.287,0,1,0-9.848,41.661c.86-1.365,1.659-2.772,2.414-4.22a62.505,62.505,0,0,0,2.688-5.754,66.371,66.371,0,0,0,4.955-22.153A69.2,69.2,0,0,0,1271.472,1650.284Zm-64.612,34.837a28.51,28.51,0,1,1,25.786-30.994A28.519,28.519,0,0,1,1206.86,1685.121Z",
    transform: "translate(36.387 19.755)",
    fill: "#642f8a"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(1202.66 1637.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M1202.049,1692.254a38.284,38.284,0,1,1,3.526-.164Q1203.8,1692.254,1202.049,1692.254Zm.057-76.053q-1.734,0-3.493.16A37.838,37.838,0,0,0,1164.4,1657.5h0a37.837,37.837,0,1,0,37.706-41.3Z",
    transform: "translate(-1163.863 -1615.823)",
    fill: "#fff"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M1295.413,1693.542a26.722,26.722,0,0,0,1.217,8.483c.274.945.546,1.807.8,2.6v.022c1.134,3.59,2.058,5.774,2.058,5.774s-11.255,4.557-15.014,2.289c-3.738-2.289-1.47-55.54-1.386-57.01v-.022c.084-1.26,1.386-9.512,1.848-12.493.125-.672.189-1.093.189-1.093,11.339-.987,10.206,8.316,9.7,14.741-.482,6.447-.314,25.2,4.41,35.32a60.946,60.946,0,0,0,4.43,7.979,55.5,55.5,0,0,0,6.048,7.9c-.356-.063-3.38-.819-7.307-4.956A52.787,52.787,0,0,1,1295.413,1693.542Z",
    transform: "translate(49.514 24.537)",
    fill: "#440c01"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M1299.485,1709.41s-11.255,4.557-15.014,2.289c-3.738-2.289-1.47-55.54-1.386-57.01v-.022a14.373,14.373,0,0,1,2.877-1.427c.84,7.475,7.266,14.951,4.914,30.7a22.773,22.773,0,0,0,6.552,19.675v.022C1298.562,1707.226,1299.485,1709.41,1299.485,1709.41Z",
    transform: "translate(49.514 25.552)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M1285.536,1666.375c-.252.358-6.719-.735-6.111-.987.189-.084.379-.629.546-1.407a34.655,34.655,0,0,0,.525-3.7,10.132,10.132,0,0,0,.063-1.029,2.077,2.077,0,0,0,.021-.336s2.709-1.994,3.612-2.078v-.021c.147-.022.252.021.294.125C1284.738,1657.682,1285.788,1666,1285.536,1666.375Z",
    transform: "translate(49.248 25.875)",
    fill: "#ffd6c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M1284.355,1656.975c.293,1.806-2.142,2.351-2.961,4.283-.63,1.491-.925,2.352-1.386,2.709a34.655,34.655,0,0,0,.525-3.7c-.5.294-1.028.567-1.554.819a3.687,3.687,0,0,1,.21-.4,6.388,6.388,0,0,1,1.407-1.449,27.806,27.806,0,0,1,3.612-2.2A1.248,1.248,0,0,1,1284.355,1656.975Z",
    transform: "translate(49.211 25.89)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M1284.772,1657.69v.021a.8.8,0,0,0-.021.209v.043c-.043.609-1.659,1.994-3.675,3.192-.5.294-1.028.567-1.554.819-1.994.966-4.052,1.491-5.207.8-2.352-1.428-1.345-8.756.944-13.649a13.717,13.717,0,0,1,1.008-1.91s3.318,1.112,5.838,2.058a.064.064,0,0,0,.041.021,10.184,10.184,0,0,1,2.772,1.259C1285,1651.012,1284.856,1656.01,1284.772,1657.69Z",
    transform: "translate(48.668 25.006)",
    fill: "#ffe2d7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M1283.4,1653.776c2.487-1.835,3.262-.082,3.058.978s-1.55,2.9-2.854,2.406S1283.4,1653.776,1283.4,1653.776Z",
    transform: "translate(49.572 25.528)",
    fill: "#ffe2d7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M1266.692,1681.3l-1.511,4.872a3.351,3.351,0,0,1-3.612,2.351c-.295-1.742-1.7-3.927-6.027-6.572-.189-.126-.377-.231-.588-.357a45.549,45.549,0,0,1-9.7-9.555c-4.661-5.9-8.167-12.431-7.559-15.1,0,0,3.864,4.514,9.24,9.68a109.049,109.049,0,0,0,10.709,9.218,51.856,51.856,0,0,0,4.85,3.192C1264.257,1680.04,1265.621,1680.775,1266.692,1681.3Z",
    transform: "translate(45.47 25.887)",
    fill: "#51197a"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M1246.088,1670.414c-.19-.126-.378-.273-.609-.462a12.957,12.957,0,0,1-1.008-.9c-3.759-3.632-8.148-10.961-6.656-13.208,1.616-2.436,5.942,4.809,6.32,5.186.356.358.651-3.843,1.05-2.289.42,1.554-.358,5.5,3.192,8.967C1248.377,1667.706,1249.28,1672.494,1246.088,1670.414Z",
    transform: "translate(45.46 25.742)",
    fill: "#ffe2d7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M1284.525,1788.961c-.063.672-5.27,1.218-5.523.735a17.127,17.127,0,0,1,.063-3.045c.126-1.827.358-4.011.567-5.25.021,0,.021,0,0-.022a4.207,4.207,0,0,1,.231-.924,1.767,1.767,0,0,1,.21-.231,21.249,21.249,0,0,1,2.918-1.974c.189.672.483,2.394.756,4.263C1284.167,1785.371,1284.546,1788.563,1284.525,1788.961Z",
    transform: "translate(49.209 36.861)",
    fill: "#ffe2d7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M1323.5,1780.312c.063.44-3.485,3.738-3.843,3.548a61.905,61.905,0,0,1-5.145-10.394,4.742,4.742,0,0,1,.63-3.464,7.4,7.4,0,0,1,.714-1.05c.86,1.218,1.763,2.52,2.6,3.759C1321.132,1776.532,1323.463,1780,1323.5,1780.312Z",
    transform: "translate(52.415 36.019)",
    fill: "#ffe2d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M1283.259,1652.063a16.8,16.8,0,0,0-8.189-2.94,13.717,13.717,0,0,1,1.008-1.91s3.318,1.112,5.838,2.058a.064.064,0,0,0,.041.021,3.194,3.194,0,0,1,1.093,1.029A4.3,4.3,0,0,1,1283.259,1652.063Z",
    transform: "translate(48.858 25.006)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M1285.743,1642.089l-.063.757-1.007,11.506s-.211-.315-.672-.882a28.234,28.234,0,0,0-2.961-3.045c-2.562-2.289-5.566-1.134-5.566-1.89,0-.693,3.57-4.619,8.316-6.026A11.893,11.893,0,0,1,1285.743,1642.089Z",
    transform: "translate(48.894 24.543)",
    fill: "#440c01"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M1287.523,1793.3c-.8.673-11.549,1.3-15.959.988-.357-.022-.694-.043-1.029-.084-3.864-.294-6.488-.63-6.614-1.134,0-.127.693-.442,1.784-.861,2.331-.9,6.551-2.289,9.89-3.276a36.8,36.8,0,0,1,4.83-1.239,18.518,18.518,0,0,0,5.333-.8,10.121,10.121,0,0,1,1.218,2.6C1287.564,1791.1,1287.985,1792.925,1287.523,1793.3Z",
    transform: "translate(47.849 37.643)",
    fill: "#2a7306"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M1328.8,1781.636c-.088,1.554-6.525,11.676-8.124,11.986a43.3,43.3,0,0,1-4.861.444c-.022,0-.045.023-.067.023-.333.022-.666.022-1.022.022-3.263.133-6.725.045-7.458-.666-.4-.4.2-.976,1.287-1.62,2.376-1.376,6.927-3.019,7.525-3.329.555-.311,1.71-2.641,2.531-4.417.444-.976.8-1.8.888-1.976.222-.554,3.352-4.75,3.352-4.75a29.928,29.928,0,0,1,2.885,1.4c.467.266.932.555,1.354.843C1328.088,1780.305,1328.82,1781.037,1328.8,1781.636Z",
    transform: "translate(51.759 36.779)",
    fill: "#2a7306"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M1318.3,1779.661s-2.646-5.837-3.213-9.659a7.4,7.4,0,0,1,.714-1.05c.86,1.218,1.763,2.52,2.6,3.759C1317.521,1773.634,1318.97,1777.644,1318.3,1779.661Z",
    transform: "translate(52.477 36.019)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M1321.339,1787.478c-.21,0-1.869-2.143-4.284-5.355-5.984-8-16.631-22.615-21.166-27.066-5.4-5.292-12.558-13.776-15.938-22.133a28.339,28.339,0,0,1-1.427-4.41c-2.205-9.659,8.441-18.352,8.441-18.352,4.41,11.025,4.893,26.668,10.9,30.826,10.542,7.328,19.3,24.652,21.88,34.5C1322.074,1784.286,1322.494,1787.415,1321.339,1787.478Z",
    transform: "translate(49.143 30.701)",
    fill: "#369106"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M1283.768,1782.515a.53.53,0,0,1-.168-.021c-1.89-.378-2.183,4.136-4.515,4.158a1.965,1.965,0,0,1-.357-.022,27.381,27.381,0,0,1,.924-5.228c.021,0,.021,0,0-.022.147-.4.273-.776.442-1.155a21.249,21.249,0,0,1,2.918-1.974C1283.2,1778.924,1283.5,1780.646,1283.768,1782.515Z",
    transform: "translate(49.189 36.861)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M1316.911,1781.973c-5.984-8-16.631-22.615-21.166-27.066-5.4-5.292-12.558-13.776-15.938-22.133,2-9.68,7.014-20.957,7.014-20.957.084,10.668-10.415,16.8,6.908,37.966C1310.3,1770.025,1315.42,1774.371,1316.911,1781.973Z",
    transform: "translate(49.286 30.851)",
    fill: "#267300"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M1279.971,1742.157c4.011,11.508,5.4,14.679,4.535,42.312-.125,4.389-4.64,10.773-5.018,9.911-.357-.86-8.924-39.393-9.659-52.475a199.65,199.65,0,0,1,.273-21.964c.063-.945.126-1.848.19-2.751.293-4.115.692-7.727,1.134-10.268v-.042a13.592,13.592,0,0,1,.86-3.254c1.7-3.3,15.392-1.953,15.392-1.953C1294.292,1711.563,1276.927,1733.338,1279.971,1742.157Z",
    transform: "translate(48.366 29.908)",
    fill: "#42ab09"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M1288.479,1703.941c-3.108,5.964-9.6,6.174-13.943,9.219-2.587,1.812-3.045,4.367-4.473,6.552.063-.945.126-1.848.19-2.751.293-4.115.692-7.727,1.134-10.268v-.042C1275.46,1705.685,1288.479,1703.941,1288.479,1703.941Z",
    transform: "translate(48.405 30.138)",
    fill: "#008c10"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M1287.912,1684.907c-3.423,10-1.281,15.476.147,19.214a10.8,10.8,0,0,1,.987,3.612c0,3.822-17.618,5.292-18.185,4.473-.567-.8,1.554-12.873,2.373-19.4a12.387,12.387,0,0,0-1.281-7.476c-.9-1.931-1.995-3.653-2.31-5.984a6.586,6.586,0,0,1,.315-2.772c1.427-4.892,7.035-11.422,10.94-12.872.651-.252,3.906.567,5.46,1.134,1.092.4,3.78,3.36,3.57,9.932v.022A33.935,33.935,0,0,1,1287.912,1684.907Z",
    transform: "translate(48.363 26.494)",
    fill: "#ffca1b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M1247.19,1666.123a24.518,24.518,0,0,1-1.679,3.317c-.19-.126-.378-.273-.609-.462a12.907,12.907,0,0,1-1.008-.9C1245.237,1667.823,1246.435,1666,1247.19,1666.123Z",
    transform: "translate(46.037 26.717)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M1285.664,1671.417c0,5.837-5.375,8.337-10.562,9.24-2.855.5-3.276,2.373-3.149,3.968-.9-1.931-1.995-3.653-2.31-5.984a6.586,6.586,0,0,1,.315-2.772C1275.607,1673.454,1285.664,1671.417,1285.664,1671.417Z",
    transform: "translate(48.363 27.196)",
    fill: "#e69600"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M1286.28,1669.327c-6.28-1.606-20.243,6.3-21.711,6.361s-17-9.725-17.552-9.6a7.475,7.475,0,0,0-2.446,2.752c0,.429,13.088,12.844,18.347,13.149s16.016-2.942,20.488-4.158c5.229-1.422,5.711-5.114,4.515-7.156A2.775,2.775,0,0,0,1286.28,1669.327Z",
    transform: "translate(46.099 26.713)",
    fill: "#ffd245"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M1286.973,1703.2c-2.225-3.045-5.585-7.391-5.355-10.478.315-4.137,4.536-10.6,7.224-18.856a33.935,33.935,0,0,1-2.016,10.121C1283.4,1693.979,1285.545,1699.46,1286.973,1703.2Z",
    transform: "translate(49.449 27.417)",
    fill: "#e69600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M1286.974,1793.086c-.8.673-11.549,1.3-15.959.988-.357-.022-.694-.043-1.029-.084,3.318-1.009,13.5-2.563,16.442-4.7C1287.016,1790.883,1287.437,1792.709,1286.974,1793.086Z",
    transform: "translate(48.398 37.859)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M1303.594,1700.135a63.749,63.749,0,0,1-5.375-4.871c-6.825-6.762-6.426-18.374-5.061-33.535,1.386-15.161-1.345-15.916-3.612-17.366a16.928,16.928,0,0,0-4.557-1.511.077.077,0,0,1-.063-.022c-.608-.125-1.239-.23-1.827-.314a11.893,11.893,0,0,1,1.953-.421c11.339-.987,10.206,8.316,9.7,14.741-.482,6.447-.314,25.2,4.41,35.32A60.946,60.946,0,0,0,1303.594,1700.135Z",
    transform: "translate(49.584 24.537)",
    fill: "#ff4747",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M1275.448,1788.766c-1.847,1.344-3.716,3.087-5.9,3.36a10.4,10.4,0,0,1-3.99-.084C1267.888,1791.139,1272.109,1789.753,1275.448,1788.766Z",
    transform: "translate(47.997 37.812)",
    fill: "#fff",
    opacity: 0.4
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M1318.5,1783.528c.125,1.071-1.344,5.124-1.848,5.838-.462.608-5.8,2.078-8.21,1.911,2.373-1.386,6.929-3.024,7.516-3.339C1316.505,1787.623,1317.66,1785.292,1318.5,1783.528Z",
    transform: "translate(51.876 37.338)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M1328.168,1781.451c-.088,1.554-6.525,11.676-8.124,11.986a43.3,43.3,0,0,1-4.861.444c-.022,0-.045.023-.067.023-.333.022-.666.022-1.022.022,2-.666,4.4-1.354,5.639-1.665,2.219-.555,6.814-9.944,6.726-12.852C1327.459,1780.119,1328.191,1780.851,1328.168,1781.451Z",
    transform: "translate(52.388 36.965)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M977.217,1647.977c-1.89,2.15-6.668,4.126-6.668,4.126-.174-.434-.326-.847-.478-1.26a15.319,15.319,0,0,1-.479-1.629c-.021-.044-.021-.087-.042-.13-1.825-7.581,1.606-13.271,2.953-14.01a.472.472,0,0,1,.131-.086s.022.044.087.151a97.3,97.3,0,0,1,5,10.1.068.068,0,0,1,.022.044c.022.065.043.109.064.173.065.217.131.435.174.609A2.19,2.19,0,0,1,977.217,1647.977Z",
    transform: "translate(21.173 23.901)",
    fill: "#440c01"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M977.847,1645.232a1.4,1.4,0,0,0-.044.217c-.108.413-.325,1.412-.586,2.52-1.89,2.15-6.668,4.126-6.668,4.126-.174-.434-.326-.847-.478-1.26a15.319,15.319,0,0,1-.479-1.629c-.021-.044-.021-.087-.042-.13-1.825-7.581,1.606-13.271,2.953-14.01l-.022.022c-.021.022-.021.043-.042.065-.7,1.521-1.868,4.344-1.478,6.755.326,2.085,1.456,5.538,3.215,5.821,1.042.173,2.693-2.455,3.541-2.5Z",
    transform: "translate(21.173 23.908)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M975.813,1652.157a.976.976,0,0,0-.065.2,55,55,0,0,0-1.455,5.408,1.768,1.768,0,0,1-.087.326v.022a14.452,14.452,0,0,1-.716,2.5c-.434.695-8.015-2.042-8.145-2.8-.131-.738,5.1-6.907,7.037-9.3.022-.043.065-.086.087-.13.022-.022.044-.022.065-.044a5.282,5.282,0,0,1,1.042-.39.076.076,0,0,1,.043-.022,1.366,1.366,0,0,1,1.151.086,1,1,0,0,1,.153.153l.043.044C975.6,1648.964,976.378,1651.027,975.813,1652.157Z",
    transform: "translate(20.839 25.063)",
    fill: "#ffe2d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M975.231,1652.151a.976.976,0,0,0-.065.2,55,55,0,0,0-1.455,5.408,1.768,1.768,0,0,1-.087.326,13.012,13.012,0,0,0-.543-3.561c-.673-1.325-.261-3.736-.565-4.193-.3-.478-.868-.629-.716-1.824v-.043a.26.26,0,0,1,.087-.087c.022-.022.044-.022.065-.044a1.678,1.678,0,0,1,1.042-.39.076.076,0,0,1,.043-.022,2.694,2.694,0,0,1,1.043.13.947.947,0,0,1,.261.109l.043.044C975.014,1648.958,975.8,1651.021,975.231,1652.151Z",
    transform: "translate(21.421 25.07)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M987.473,1642.1c-.022.587-.086,1.173-.152,1.8-.716,6.32-3.562,14.488-7.645,15.421-4.5,1.021-6.537-4.148-6.364-8.644s6.451-10.448,7.558-10.273c.587.086,2.5.586,4.127,1.021C986.344,1641.774,987.473,1642.1,987.473,1642.1Z",
    transform: "translate(21.559 24.391)",
    fill: "#ffe2d7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M975.012,1646.49c-.594-2.462-2.226-2.474-3.141-1.4-.795.935-.933,4.584,1.7,4.839S975.012,1646.49,975.012,1646.49Z",
    transform: "translate(21.384 24.753)",
    fill: "#ffe2d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M987.122,1642.015c-.022.587-.086,1.173-.152,1.8-2.3,1.434-7.993.5-9.8.521a71.136,71.136,0,0,1,7.472-3C985.994,1641.689,987.122,1642.015,987.122,1642.015Z",
    transform: "translate(21.91 24.475)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M987.691,1643.253c-5.256,2.129-7.6,1.173-10.143,2.15-.044.022-.065.022-.108.044-2.216.869-2.606,1.759-2.606,1.759l-.391-1.91-2.063-9.927-.044-.217a.509.509,0,0,1,.173-.044,12.561,12.561,0,0,1,3.041-.63c5.495-.586,12.684.978,14.226.587,1.737-.434,4.126-1.911,5.234-1.89a.738.738,0,0,1,.239.022C996.227,1633.5,992.969,1641.146,987.691,1643.253Z",
    transform: "translate(21.472 23.737)",
    fill: "#440c01"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M969.005,1783.747c-.022.131-.022.282-.042.413-.218,2.149-.413,3.931-.435,4.343-.065,1.26-8.9,3.736-7.189-1.737a28.039,28.039,0,0,0,1.086-7.841v-.043c.065-2.693-.087-5.409-.2-7.971-.022-.652-.044-1.325-.065-1.955,0,0,7.189,5.409,7.45,6.3A79.831,79.831,0,0,1,969.005,1783.747Z",
    transform: "translate(20.457 36.02)",
    fill: "#ffdbc6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M1002.077,1787.451c.173-1.021-.5-4.257-1.846-7.8a35.194,35.194,0,0,0-2.868-5.908,20.122,20.122,0,0,0-1.824-2.519s7.559.325,9.231,1.281c1.086.629,2.389,5.278,3.758,8.688a1.9,1.9,0,0,0,.153.37c.651,1.65,1.325,2.975,2,3.279C1011.5,1785.236,1001.773,1789.363,1002.077,1787.451Z",
    transform: "translate(23.571 36.225)",
    fill: "#ffdbc6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M986.657,1794.153c-.282.369-2.28,1.107-5.1,1.564a29.9,29.9,0,0,1-10.36-.175c-7.45-1.52-10.708-.3-11.534-1.021-.5-.434-.543-2.954.044-5.517a10.872,10.872,0,0,1,1.933-4.409c.326-.37,7.059,1.281,7.754,1.542.716.239,2.171,1.52,4.6,3.106a5.592,5.592,0,0,0,1.086.543c2,.891,5.56,1.933,8.21,2.8C985.354,1793.284,986.874,1793.849,986.657,1794.153Z",
    transform: "translate(20.29 37.43)",
    fill: "#2a7306"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M1028.831,1787.777c.044.565-1.607,1.542-3.888,2.5-3.606,1.5-8.8,2.954-11.556,2.585-4.5-.587-11.121.521-12.4.086-.782-.261-.695-3-.3-5.191a6.188,6.188,0,0,1,.913-2.781s7.037-1.281,8.644-1.26,2.389.826,5.256,1.846a6.687,6.687,0,0,0,1.26.3c2.911.521,8.232.608,10.73,1.173h.022C1028.31,1787.212,1028.81,1787.451,1028.831,1787.777Z",
    transform: "translate(24.01 37.355)",
    fill: "#2a7306"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M1008.726,1781.348a.685.685,0,0,1-.2.065c-2.216.782-7.458-3.325-8.327-3.477-.564-.087-.122,1.174-.122,1.566a35.194,35.194,0,0,0-2.868-5.908.918.918,0,0,1,.044-.629c.521-.739,9.274,6.537,11.12,8.079C1008.6,1781.239,1008.726,1781.348,1008.726,1781.348Z",
    transform: "translate(23.72 36.378)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M1011.677,1787.734c-.37.5-8.645-2.562-14.64-10.838-.239-.347-.5-.695-.738-1.021-5.626-7.906-10.187-15.638-12.881-30.429-2.193-12.1-6.429-14.226-9.143-18.223a12.67,12.67,0,0,1-1.8-3.931c-2.042-7.494.89-15.9,2.541-16.79s9.817,3.931,9.817,3.931c4.062,11.968,9.535,28.909,11.316,37.185S1012.068,1787.213,1011.677,1787.734Z",
    transform: "translate(21.421 30.36)",
    fill: "#369106"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M996.092,1775.277c-5.626-7.906-10.187-15.638-12.881-30.429-2.193-12.1-6.429-14.226-9.143-18.223.869-5.69,2.628-13.619,2.628-13.619,3.453,16.573,8.491,27.171,10.512,35.448C989.355,1757.246,993.073,1768.913,996.092,1775.277Z",
    transform: "translate(21.629 30.958)",
    fill: "#267300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M969.152,1784.084a1.458,1.458,0,0,1-.281-.086c-2.629-.761-5.582-6.473-6.039-6.473-.261,0-.39.63-.5,1.2.065-2.693-.087-5.409-.2-7.971.869.695,5.647,10.49,6.776,12.836C969.066,1783.911,969.152,1784.084,969.152,1784.084Z",
    transform: "translate(20.549 36.182)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M978.123,1739.3c-1.542,8.9-8.015,51.563-8.666,52.062-.63.521-6.626-7.884-7.386-12.076-.76-4.214-1.26-17.572.891-29.04,2.172-11.446,5.734-11.207,3.692-21.524-.261-1.3-.565-2.607-.891-3.889-1.824-7.168-4.343-13.878-3.432-20.525a18.6,18.6,0,0,1,1.152-4.474c3.692-9.3,15.008,7.254,15.008,7.254.022,1.239.044,2.433.087,3.541,0,.434.022.847.022,1.26C979.012,1726.77,979.513,1731.2,978.123,1739.3Z",
    transform: "translate(20.485 29.511)",
    fill: "#42ab09"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M980.582,1711.111a12.812,12.812,0,0,1-2.041.173c-5.148.131-10.534-1.868-11.815.326-1.3,2.237-.044,10.534-1.022,12.619-1.824-7.168-4.343-13.878-3.432-20.525,4.344.521,12.445,4.409,16.247,6.32C979.8,1710.7,980.582,1711.111,980.582,1711.111Z",
    transform: "translate(20.544 30.117)",
    fill: "#008c10"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M989.8,1718.7c-.325.435-21.068-5.212-27.909-8.057-1.259-.543-2.041-.955-2.15-1.238-.63-1.782,2.8-5.6,1.281-12.6-.89-4.148-3.475-12.424-4.409-20.677-.63-5.668-.5-11.316,1.477-15.616,4.452-9.665,16.42-1.65,17.311-1,5.387,3.823,4.844,11.077,7.775,30.668.065.413.131.825.174,1.217.955,6.1,2.02,11.077,3,15.03C988.362,1714.6,990.035,1718.379,989.8,1718.7Z",
    transform: "translate(20.019 25.782)",
    fill: "#ffca1b"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "matrix(0.88, -0.475, 0.475, 0.88, 1006.387, 1679.588)",
    fill: "#6a398f"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "translate(1025.872 1673.587) rotate(17.895)",
    fill: "#6a398f"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "translate(1012.493 1715.251) rotate(17.895)",
    fill: "#f8bbd0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "translate(1026.549 1718.382) rotate(-28.33)",
    fill: "#6a398f"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "matrix(0.466, 0.885, -0.885, 0.466, 1043.471, 1682.85)",
    fill: "#6a398f"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "matrix(0.466, 0.885, -0.885, 0.466, 1004.511, 1702.801)",
    fill: "#6a398f"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 11.218,
    height: 7.737,
    rx: 1.032,
    transform: "translate(1007.717 1688.885) rotate(107.112)",
    fill: "#6a398f"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M1023.973,1675.757l-2.134,6.942-.5,1.624a1.119,1.119,0,0,1-1.2.784.694.694,0,0,1-.2-.035l-2.807-.868-2.435-.749a1.122,1.122,0,0,1-.742-1.407l.748-2.435.56-1.806,1.329-4.331a1.123,1.123,0,0,1,1.407-.743l2.484.763,2.758.854A1.118,1.118,0,0,1,1023.973,1675.757Z",
    transform: "translate(25.231 27.311)",
    fill: "#6a398f"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M1023.576,1672.2a22.424,22.424,0,1,0-3.282,13.885c.287-.455.553-.924.8-1.407a20.631,20.631,0,0,0,.9-1.918,22.107,22.107,0,0,0,1.651-7.383A22.982,22.982,0,0,0,1023.576,1672.2Zm-21.533,11.61a9.5,9.5,0,1,1,8.594-10.329A9.5,9.5,0,0,1,1002.043,1683.815Z",
    transform: "translate(22.06 25.425)",
    fill: "#6a398f"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(1010.576 1686.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M1000.442,1686.193a12.753,12.753,0,0,1-12.673-11.57h0a12.734,12.734,0,1,1,13.846,11.515C1001.221,1686.174,1000.829,1686.193,1000.442,1686.193Zm.031-25.348q-.587,0-1.179.055a12.61,12.61,0,0,0,1.148,25.167q.576,0,1.161-.053a12.611,12.611,0,0,0-1.131-25.168Z",
    transform: "translate(-987.714 -1660.719)",
    fill: "#fff"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M977.425,1682.815c5.883,0,19.457,9.683,23.983,8.869s11.674-3.53,13.485-2.172-8.959,7.421-16.2,6.153S977.425,1682.815,977.425,1682.815Z",
    transform: "translate(21.932 28.227)",
    fill: "#581b85"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M1003.9,1697.644a12.4,12.4,0,0,1-6.233.065,16.141,16.141,0,0,1-3.627-1.261c-.3-.152-.457-.239-.457-.239l1.347-4.518c1.76.652,2.889,1.282,3.8,1.585h.022v.022a2.864,2.864,0,0,0,2.475-.2c1.911-1.021,12.642-6.1,13.75-4.409C1016.067,1690.389,1009.074,1696.124,1003.9,1697.644Z",
    transform: "translate(23.394 28.728)",
    fill: "#ffe2d7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M986.008,1705.952a27.043,27.043,0,0,0-3.628-6.429c-4.148-5.495-8.232-3.475-14.943-10.317-6.712-6.863-9.3-23.088-6.1-28.106,0,0,14.139,25.348,21.676,29.822C983.965,1697.025,985.03,1702,986.008,1705.952Z",
    transform: "translate(20.354 26.263)",
    fill: "#e69600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M997.633,1697.3a16.141,16.141,0,0,1-3.627-1.261c0-.173.108-.325.325-.521a42.171,42.171,0,0,1,4.366-2.65h.022v.022c.369.739-2.172,2.824-2.085,3.367C996.7,1696.6,997.263,1697.018,997.633,1697.3Z",
    transform: "translate(23.432 29.137)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M963.016,1659.343c11.692-3.5,12.329,22.153,14,25.209a16.587,16.587,0,0,1,5.009,1.272c5.411,2.292,18.822,9.444,19.734,10.1.555.4-2.758,3.48-3.522,3.735s-23.257-5.942-27.331-9.083S955.275,1661.662,963.016,1659.343Z",
    transform: "translate(20.393 26.074)",
    fill: "#ffd245"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M981.553,1795.347a29.9,29.9,0,0,1-10.36-.175c-7.45-1.52-10.708-.3-11.534-1.021-.5-.434-.543-2.954.044-5.517,1,2.954,3.866,4.235,6.907,4.474C969.108,1793.326,977.513,1794.521,981.553,1795.347Z",
    transform: "translate(20.29 37.8)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M1024.944,1789.939c-3.606,1.5-8.8,2.954-11.556,2.585-4.5-.587-11.121.521-12.4.086-.782-.261-.695-3-.3-5.191,1.412,2.606,8.037,3.866,11.359,3.822C1015.039,1791.2,1021.881,1789.9,1024.944,1789.939Z",
    transform: "translate(24.01 37.69)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M994.743,1633.175c-.173,1.39-2.02,4.344-5.061,6.256-3.5,2.172-9.6-3.453-14.4-4.953,5.495-.586,12.684.978,14.226.587C991.246,1634.631,993.635,1633.153,994.743,1633.175Z",
    transform: "translate(21.739 23.737)",
    fill: "#ff4747",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M972.335,1634.988",
    transform: "translate(21.472 23.901)",
    fill: "#440c01"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M982.153,1792.161c-1.629.847-6.3.37-8.58-.955-2.3-1.347-2.411-2.238.37-1.846C975.94,1790.251,979.5,1791.293,982.153,1792.161Z",
    transform: "translate(21.428 37.857)",
    fill: "#fff",
    opacity: 0.4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M1026.127,1786.86a3.683,3.683,0,0,1-2.129.826,13.777,13.777,0,0,1-8.6-2C1018.309,1786.208,1023.629,1786.3,1026.127,1786.86Z",
    transform: "translate(25.367 37.533)",
    fill: "#fff",
    opacity: 0.4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M963.81,1698.448c-.675,2.821-3.559,7.166-1.952,10.51-1.259-.543-2.041-.955-2.15-1.238-.63-1.782,2.8-5.6,1.281-12.6-.89-4.148-3.475-12.424-4.409-20.677C960.551,1689.354,964.557,1695.326,963.81,1698.448Z",
    transform: "translate(20.047 27.47)",
    fill: "#e69600"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(1094.56 1588.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M1130.4,1606.023a83.078,83.078,0,0,1-23.068,3.079c-23.53,0-42.6-8.654-42.6-19.331s19.074-19.331,42.6-19.331,42.6,8.654,42.6,19.331c0,4.6-3.542,8.828-9.455,12.155",
    transform: "translate(-1064.73 -1570.441)",
    fill: "#b363a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M1124.954,1603.411l15.522,7.7-5.441-11.8",
    transform: "translate(-1059.282 -1567.829)",
    fill: "#b363a8"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 51.875,
    cy: 23.542,
    rx: 51.875,
    ry: 23.542,
    transform: "translate(1035.709 1594.027)",
    fill: "#8a3380"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M1023.532,1607.365l-8.281,17.969,21.406-10.625Z",
    transform: "translate(25.354 21.402)",
    fill: "#8a3380"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(1070.475 1612.829)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M1054.034,1597.437a4.688,4.688,0,1,1,4.688,4.687A4.687,4.687,0,0,1,1054.034,1597.437Z",
    transform: "translate(-1041.613 -1592.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M1042.643,1597.294a2.969,2.969,0,1,1,2.968,2.968A2.969,2.969,0,0,1,1042.643,1597.294Z",
    transform: "translate(-1042.643 -1592.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M1068.578,1597.294a2.969,2.969,0,1,1,2.969,2.968A2.969,2.969,0,0,1,1068.578,1597.294Z",
    transform: "translate(-1040.297 -1592.607)",
    fill: "#fff"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M876.09,1713.161c6.255-13.952,8.051-13.409,11.918-17.283,4.268-4.277,6-7.9,7.184-7.742,2.028.271,2.653,4.839.063,9.137-2.726,4.523-4.459,5.716-4.121,6.437s19.44,0,21.552,0a4.3,4.3,0,0,1,4.058,4.68c-.338,2.521-4.227,14.853-7.184,16.294s-33.639.54-34.146,0S876.09,1713.161,876.09,1713.161Z",
    transform: "translate(12.693 28.708)",
    fill: "#f0b3c3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M880.922,1726.44l-6.683,4.1a1.1,1.1,0,0,1-1.647-.712l-4.675-22.487a1.1,1.1,0,0,1,1.113-1.319l7.639.27a1.1,1.1,0,0,1,1.035.875l3.718,18.117A1.1,1.1,0,0,1,880.922,1726.44Z",
    transform: "translate(12.024 30.326)",
    fill: "#e08da4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M1329.239,1460.369a13.477,13.477,0,0,0-13.482,13.44v.034c0,.092,0,.184.008.276s.009.184.009.276a.763.763,0,0,0,0,.142,13.486,13.486,0,0,0,11.585,12.664,13.962,13.962,0,0,0,1.881.125,12.522,12.522,0,0,0,1.864-.133,13.476,13.476,0,0,0-1.864-26.823Zm5.542,13.474c0,.092-.009.192-.017.285a5.515,5.515,0,0,1-4.071,5.057,5.206,5.206,0,0,1-1.454.2,5.107,5.107,0,0,1-1.388-.183,5.52,5.52,0,0,1-4.146-5.083v-.025c-.008-.084-.008-.167-.008-.251v-.059a5.542,5.542,0,0,1,11.083,0Z",
    transform: "translate(52.538 8.104)",
    fill: "#f0b3c3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M1341.849,1472.73c0,19.543-13.483,26.748-13.483,26.748l-.009-.034v-.016l-1.872-13.341-1.095-7.815a7.477,7.477,0,0,0,1.588-.183,5.111,5.111,0,0,0,1.388.183,5.2,5.2,0,0,0,1.454-.2,5.515,5.515,0,0,0,4.071-5.057c.009-.093.017-.193.017-.284v-.059Z",
    transform: "translate(53.41 9.217)",
    fill: "#f0b3c3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M1332.215,1478.272l-1.1,7.84-1.872,13.348v.016s-13.482-7.2-13.482-26.747h.009l7.932-.059v.059c0,.092.009.192.016.283v.025a5.52,5.52,0,0,0,4.146,5.083,5.1,5.1,0,0,0,1.388.183,5.2,5.2,0,0,0,1.454-.2A7.794,7.794,0,0,0,1332.215,1478.272Z",
    transform: "translate(52.538 9.217)",
    fill: "#f0b3c3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.a20072d4f312201705fa493356c65170.svg";
export { ForwardRef as ReactComponent };